import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import { sampleReducer } from "./sampleReducer";
import storage from "redux-persist/lib/storage";
import { createStudentReducer } from "./createStudentReducer";
import { pgReducer } from "./pgReducer";
import { directEntryReducer } from "./directEntryReducer";
import { jupebApplicationReducer } from "./jupebReducer";
import { putmeReducer } from "./putmeReducer";
import { menuItemsReducer } from "./menuItemsReducer";
import { CSPGReducer } from "./CSPGReducer";
import { transferReducer } from "./transferReducer";
import { impersonatorReducer } from "./impersonatorReducer";

const persistConfig = {
	key: "root",
	storage,
	whitelist: [
		"studentData",
		"pgData",
		"directEntryData",
		"transferData",
		"jupebData",
		"putmeData",
		"menuItemsData",
		"CSPGData",
		"impersonatorDetails"
	]
};

const rootReducer = combineReducers({
	sample: sampleReducer,
	studentData: createStudentReducer,
	pgData: pgReducer,
	directEntryData: directEntryReducer,
	jupebData: jupebApplicationReducer,
	putmeData: putmeReducer,
	menuItemsData: menuItemsReducer,
	CSPGData: CSPGReducer,
	transferData: transferReducer,
	impersonatorDetails: impersonatorReducer,
});

export default persistReducer(persistConfig, rootReducer);
